snt-link {
    a {
        @include customizeLink(theme);
        font-size: inherit;
        position: relative;
        text-decoration: none;
        background-color: transparent; // Remove the gray background on active links in IE 10.
        padding-bottom: 1px;
        background-image: linear-gradient($color-primary-accent, $color-primary-accent), linear-gradient($color-links, $color-links);
        background-size: 100% 1px, 0 1px;
        background-position: 100% 100%, 1px 100%;
        background-repeat: no-repeat;
        white-space: pre-wrap;
        .icon-new-window:before,
        .icon-global-download:before {
            color: $color-primary-accent;
        }
        .icon-global-download:after {
            all: unset;
        }
        .icon-global-download:before {
            content: "\e924";
            font-size: 16px !important;
            right: -21px;
            position: absolute;
            top: 60%;
            vertical-align: middle;
            color: $color-primary-accent;
            transform: translateY(-50%);
        }
        &:hover {
            text-decoration: none;
            background-image: linear-gradient(transparent, transparent), linear-gradient($color-links, $color-links);
            background-size: 0 1px, 100% 1px;
            -webkit-transition: all 0.25s ease-in-out 0s;
            transition: all 0.25s ease-in-out 0s;
            transition-property: background-size;
        }
        &:focus {
            padding: 1px;
            box-sizing: border-box;
            margin: -1px;
            background-image: linear-gradient(transparent, transparent), linear-gradient($color-links, $color-links);
            background-size: 0 1px, 100% 1px;
            -webkit-transition: all 0.25s ease-in-out 0s;
            transition: all 0.25s ease-in-out 0s;
            transition-property: background-size;
        }
        &:active {
            outline: none;
        }
        span.icon-font.icon-new-window,
        span.icon-font.icon-global-download {
            position: relative;
            right: 0;
        }
    }
    @include applySntLinkThemes() {
        a {
            color: $color-primary-accent;
            &:before {
                background-color: $color-links;
            }
            &:focus {
                outline: 1px solid $color-primary-accent;
                outline-offset: 2px;
            }
            &:hover,
            &:focus {
                color: $color-links;
                .icon-new-window:before {
                    color: $color-links;
                }
                .icon-global-download:before {
                    color: $color-links;
                }
            }
        }
    }
    a.theme-link {
        font-size: 0.875em;
        font-weight: bold;
        color: $color-primary-grey;
        &:hover,
        &:focus {
            color: $color-primary-accent;
            &:before {
                background: $color-primary-accent;
            }
        }
        &:focus {
            outline: 1px solid $color-primary-grey;
        }
    }
    a.theme-action {
        font-family: 'Averta-ExtraBold';
        font-weight: 500;
        text-decoration: none;
        background-image: none;
        &:before {
            height: 3px;
            bottom: -3px;
            background-color: $color-primary-accent;
        }
        &:hover,
        &:focus {
            text-decoration: none;
            &:before {
                all: unset;
            }
            .link-content {
                background-image: linear-gradient(transparent, transparent), linear-gradient($color-primary-accent, $color-primary-accent);
                background-size: 0 3px, 100% 3px;
                -webkit-transition: all 0.25s ease-in-out 0s;
                transition: all 0.25s ease-in-out 0s;
            }
            .icon-new-window:after,
            .icon-global-download:before {
                color: $color-primary-accent;
            }
        }
        .link-content {
            padding-bottom: 3px;
            background-image: linear-gradient($color-primary-grey, $color-primary-grey), linear-gradient($color-primary-accent, $color-primary-accent);
            background-size: 100% 3px, 0 3px;
            background-position: 100% 100%, 0 100%;
            background-repeat: no-repeat;
        }
        .icon-new-window:before {
            all: unset;
        }
        .icon-new-window:after {
            content: "\e960";
            font-size: 1.02em!important;
            right: auto;
            margin-left: 5px;
            padding-left: 5px;
            color: $color-primary-grey;
            display: inline-block;
        }
        .icon-global-download:after {
            color: $color-primary-grey;
        }
    }
    a.cta {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
        box-sizing: border-box;
        padding: 13px 21px;
        font-size: 1.125em;
        width: auto;
        cursor: pointer;
        line-height: normal;
        font-family: "Averta-ExtraBold", sans-serif;
        overflow: visible;
        outline: none;
        -webkit-font-smoothing: inherit;
        /* Corrects font smoothing for webkit */
        -moz-osx-font-smoothing: inherit;
        -webkit-appearance: none;
        /* Corrects inability to style clickable `input` types in iOS */
        border: none;
    }
}

p snt-link[target=_blank],
snt-link[download] {
    padding-right: 25px;
    white-space: nowrap;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    snt-link a {
        font-family: "Averta-ExtraBold", sans-serif
    }
}
snt-link {
    a.clsBtnLink{
        white-space: normal;
        font-size: inherit;
    }
}